import { tv, type VariantProps } from 'tailwind-variants';
export type OrHomePlansCarouselVariants = VariantProps<
  typeof orHomePlansCarousel
>;

const orHomePlansCarousel = tv({
  slots: {
    base: '',
    headingSection:
      'flex mb-12 flex-col items-center px-6 lg:mb-[3.38rem] lg:justify-between lg:flex-row lg:items-end',
  },
  variants: {
    size: {
      sm: 'text-md',
      lg: 'text-lg',
    },
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
  },
  compoundVariants: [],
});

export default orHomePlansCarousel;
